import React, { useContext, useState } from 'react';
import { useShipForm } from '../../../context/shipForms';
import { AbilityContext } from '../../../context/AbilityContext';

function PaymentRates() {
  const { getFinalRateContext } = useShipForm();
  const ability = useContext(AbilityContext);
  const [isPriceHidden, setIsPriceHidden] = useState<any>(
    !ability.can('read', 'View Price')
  );
  const finalRateContext: any = getFinalRateContext();
  return (
    <div className='ubbe-card'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Total Cost</h5>
      </div>
      <div className='card-body p-4'>
        <div className='row mt-2'>
          <div className='col'>
            <span className='fw-bold'>Rate Option</span>
          </div>
          <div className='col-md-auto'>
            <label id='payment_rate_option'>ubbe</label>
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col'>
            <span className='fw-bold'>Savings</span>
          </div>
          <div className='col-md-auto'>
            <label id='payment_promo'>
              $
              {isPriceHidden
                ? '-'
                : finalRateContext?.savings
                ? Number(finalRateContext?.savings).toFixed(2)
                : '0.00'}{' '}
              CAD
            </label>
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col'>
            <span className='fw-bold'>Sub Total</span>
          </div>
          <div className='col-md-auto'>
            <label id='payment_sub_total'>
              $
              {isPriceHidden
                ? '-'
                : finalRateContext?.subTotal
                ? Number(finalRateContext?.subTotal).toFixed(2)
                : '0.00'}{' '}
              CAD
            </label>
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col'>
            <span className='fw-bold'>Taxes</span>
          </div>
          <div className='col-md-auto'>
            <label id='payment_tax'>
              {' '}
              $
              {isPriceHidden
                ? '-'
                : finalRateContext?.tax
                ? Number(finalRateContext?.tax).toFixed(2)
                : '0.00'}{' '}
              CAD
            </label>
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col'>
            <span className='fw-bold'>Insurance</span>
          </div>
          <div className='col-md-auto'>
            <label id='payment_insurance'>
              $
              {isPriceHidden
                ? '-'
                : finalRateContext?.insurance
                ? Number(finalRateContext?.insurance).toFixed(2)
                : '0.00'}{' '}
              CAD
            </label>
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col'>
            <span className='fw-bold'>Total</span>
          </div>
          <div className='col-md-auto'>
            <label id='payment_total'>
              $
              {isPriceHidden
                ? '-'
                : finalRateContext?.total
                ? Number(finalRateContext?.total).toFixed(2)
                : '0.00'}{' '}
              CAD
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentRates;
